
import React, { useEffect, useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Axios from "axios";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import Pagination from "react-js-pagination";
import Spinner from "../component/Spinner";
import { buildDanhMucTree } from "./DanhMucCauHoiManager";

const LOAI_LABEL = {
    single: "Trắc nghiệm 1 đáp án",
    multiple: "Trắc nghiệm nhiều đáp án",
    sort: "Sắp xếp vị trí",
    match: "Nối cột",
    essay: "Tự luận",
};

const stripHtml = (s) => (s || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

// Modal chọn NHIỀU câu hỏi từ ngân hàng, ẩn các câu đã có trong đề.
// Props: show, onHide, existingIds (mảng cauhoi_id đã có), onConfirm(idsArray)
export default function ChonCauHoiModal({ show, onHide, existingIds = [], onConfirm }) {
    const { user } = useSelector((state) => state.auth);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const [keyword, setKeyword] = useState('');
    const [searchKey, setSearchKey] = useState('');
    const [selected, setSelected] = useState({}); // { cauhoi_id: true }
    const [danhMucList, setDanhMucList] = useState([]);
    const [danhMucId, setDanhMucId] = useState(''); // lọc theo danh mục

    const limit = 20;
    const existSet = new Set((existingIds || []).map(String));

    // Load danh sách danh mục để lọc
    useEffect(() => {
        if (!show) return;
        Axios.get(URL_LIST_ALL + "learninghub_danhmuc?status=1&limit=500&orderby=position-asc", user.config)
            .then((res) => { if (res.data.status === "success") setDanhMucList(res.data.data || []); })
            .catch((err) => console.log(err));
    }, [show, user]);

    const load = useCallback(() => {
        if (!show) return;
        setLoading(true);
        const url = URL_LIST_ALL + "learninghub_cauhoi?status=1&limit=" + limit + "&page=" + page
            + (searchKey ? "&key=" + encodeURIComponent(searchKey) : "")
            + (danhMucId ? "&danhmuc_id=" + danhMucId : "");
        Axios.get(url, user.config)
            .then((res) => {
                setLoading(false);
                if (res.data.status === "success") {
                    setList(res.data.data || []);
                    setTotalRecord(res.data.total || 0);
                } else console.log(res.data.message);
            })
            .catch((err) => { console.log(err); setLoading(false); });
    }, [show, page, searchKey, danhMucId, user]);// eslint-disable-line

    useEffect(() => { load(); }, [load]);

    // Reset khi mở lại
    useEffect(() => {
        if (show) { setSelected({}); setPage(1); setKeyword(''); setSearchKey(''); setDanhMucId(''); }
    }, [show]);

    const danhMucTree = buildDanhMucTree(danhMucList);

    const doSearch = () => { setPage(1); setSearchKey(keyword.trim()); };

    const toggle = (id) => {
        const k = String(id);
        setSelected((prev) => {
            const next = { ...prev };
            if (next[k]) delete next[k]; else next[k] = true;
            return next;
        });
    };

    // Câu chưa có trong đề (ẩn câu đã thêm)
    const visible = list.filter((c) => !existSet.has(String(c.id)));
    const selectedCount = Object.keys(selected).length;

    const confirm = () => {
        const ids = Object.keys(selected).map(Number);
        if (ids.length === 0) { onHide(); return; }
        onConfirm(ids);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Chọn câu hỏi từ ngân hàng</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 col-sm-7">
                        <div className="input-group mb-3">
                            <input type="text" className="form-control height32" placeholder="Tìm theo nội dung câu hỏi" value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); doSearch(); } }} />
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-sm btn-success height32" onClick={doSearch}><span className="fas fa-search"></span></button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-5 form-group">
                        <select className="form-select height32" value={danhMucId} onChange={(e) => { setPage(1); setDanhMucId(e.target.value); }}>
                            <option value="">-- Tất cả danh mục --</option>
                            {danhMucTree.map((d) => (
                                <option key={d.id} value={d.id}>{' '.repeat(d.depth * 3)}{d.depth > 0 ? '└ ' : ''}{d.title}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {loading
                    ? <div className="w-100 text-center py-3"><Spinner /></div>
                    : visible.length === 0
                        ? <div className="alert alert-warning">Không có câu hỏi nào (hoặc tất cả đã được thêm vào đề).</div>
                        : <ul className="w-100 list-data" style={{ maxHeight: 400, overflowY: 'auto', listStyle: 'none', padding: 0 }}>
                            {visible.map((c) => (
                                <li key={c.id} className="border-bottom py-2 px-1 d-flex align-items-start" style={{ cursor: 'pointer' }} onClick={() => toggle(c.id)}>
                                    <input type="checkbox" className="mr-2 mt-1" checked={!!selected[String(c.id)]} onChange={() => toggle(c.id)} onClick={(e) => e.stopPropagation()} />
                                    <div>
                                        <div>{stripHtml(c.title)}</div>
                                        <small className="text-muted">{LOAI_LABEL[c.loai] || c.loai}{c.tags ? ' · ' + c.tags : ''}</small>
                                    </div>
                                </li>
                            ))}
                        </ul>}

                {totalRecord > limit &&
                    <div className="w-100 pagination-group mt-2">
                        <Pagination activePage={page} itemsCountPerPage={limit} totalItemsCount={totalRecord}
                            pageRangeDisplayed={5} itemClass="page-item" linkClass="page-link"
                            prevPageText="<" nextPageText=">" onChange={setPage} />
                    </div>}
            </Modal.Body>
            <Modal.Footer>
                <span className="mr-auto">Đã chọn: <strong>{selectedCount}</strong> câu</span>
                <button type="button" className="btn btn-secondary" onClick={onHide}>Đóng</button>
                <button type="button" className="btn btn-success" disabled={selectedCount === 0} onClick={confirm}>
                    <span className="fas fa-plus"></span> Thêm {selectedCount > 0 ? selectedCount + ' câu' : ''}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
